import { ScrollArea } from '@/components/ui/scroll-area';
import { useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { FC } from 'react';

import { useMasterApprenticesTable } from '@/features/teacher-student/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TableSkeleton } from '../../../table-skeleton/table-skeleton';

export const TableDistrict: FC = () => {
  const { open } = useSidebar();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { columns, masterApprentices, isMasterApprenticesLoading } =
    useMasterApprenticesTable();

  const hasData = masterApprentices && masterApprentices.length > 0;

  return (
    <div className="w-full rounded-10 border bg-white overflow-hidden">
      <ScrollArea
        className={cn(open ? 'w-[calc(100vw-320px)]' : 'w-[calc(100vw-150px)]')}
      >
        <table className="min-w-full border-collapse text-sm">
          {/* THEAD DOIM KO'RINADI */}
          <thead>
            <tr className="bg-gray-100 text-left text-gray-700">
              {columns.map((col, i) => (
                <th
                  key={col.key}
                  className={cn(
                    'px-4 py-3 border-b font-semibold',
                    i > 1 && 'text-center',
                  )}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="text-gray-800">
            {isMasterApprenticesLoading ? (
              <TableSkeleton columns={columns.length} />
            ) : hasData ? (
              masterApprentices!.map((row, idx) => (
                <tr
                  key={idx}
                  className="hover:bg-gray-50 transition border-b last:border-none"
                >
                  {columns.map((col, index) => (
                    <td
                      key={col.key}
                      className={cn(
                        'px-4 py-3',
                        index > 1 && 'text-center',
                        col.key === 'master_name' &&
                          'font-semibold text-dark-blue cursor-pointer hover:underline',
                      )}
                      onClick={() =>
                        col.key === 'master_name' &&
                        navigate(`agro-technical-events/${row?.master_id}`)
                      }
                    >
                      {row[col.key as keyof typeof row]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              /* EMPTY ROW */
              <tr>
                <td colSpan={columns.length}>
                  <div className="flex h-[260px] flex-col items-center justify-center gap-3 text-gray-500">
                    <p className="text-sm font-medium text-gray-600">
                      {t('nothing.found')}
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </ScrollArea>
    </div>
  );
};
